import React, { useState, useEffect } from 'react';
import styled from "styled-components"
import Button from "./Button";
import { ReactComponent as StartGameIcon } from "../img/icons/playGame.svg"
import { ReactComponent as EndGameIcon } from "../img/icons/endGame.svg"
import startGameIcon from "../img/icons/playGame.svg"
import endGameIcon from "../img/icons/endGame.svg"
import Modal from "./Modal";
import { useSelector } from "react-redux"
import { ModalContainer, Header, Footer, Description, Buttons, ModalIcon, Score } from "./SingleElimination"
import axios from "axios"
import { useParams } from 'react-router';

export const Container = styled.div`
	max-width: 1089px;
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme.color.background};

`
const RoundText = styled.p`
	color: ${({ theme }) => theme.color.darkerText};
	font-family: "Poppins Bold";
	font-size: 16px;
	margin-bottom: 17px;
	@media (max-width: 700px) {
		font-size: 12px;
	}
`
export const Text = styled.p`
	color: ${({ theme, playing }) => playing ? theme.color.background : theme.color.darkerText};
	font-family: "Poppins Medium";
	font-size: 16px;
	text-align: ${({ index }) => index ? 'left' : 'right'};
	margin: ${({ middle }) => middle ? '0 4px' : ''};
	text-align: center;
    vertical-align: middle;
    line-height: 33px;
	@media (max-width: 700px) {
		font-size: 10px;
	}
`
export const Flag = styled.img`
	width: 30px;
	height: 30px;
	margin-right: ${({ first }) => first ? '0px' : '2%'};
	margin-left: ${({ first }) => first ? '2%' : '0'};
	@media (max-width: 700px) {
		width: 20px;
		height: 20px;
	}
	object-fit: cover;
	border-radius: 7px;
`
export const Match = styled.div`
	padding: 0 10px;
	position: relative;
	height: 50px;
	width: 100%;
	display: flex;
	align-items: center;
	background-color: ${({ theme, odd, playing }) => (playing) ? theme.color.primary : (odd) ? theme.color.background : theme.color.secondaryBg};
`
const Info = styled.div`
	opacity: ${({ lose }) => lose ? '0.5' : '1'};
	display: flex;
	flex: 1;
	align-items: center;
	height: 100%;
	justify-content: ${({ first }) => first ? "flex-end" : "flex-start"};
`
const Team = styled.div`
	display: flex;
	width: 49%;
	gap: 10px;
	justify-content: ${({ first }) => first ? 'space-between' : 'flex-start'};
`
const ScoreStyle = styled(Score).attrs({
	min: "0"
})`
	width: 43px;
	margin:0;
	color: ${({ theme, playing }) => playing ? theme.color.background : theme.color.darkerText};
	text-align: ${({ first }) => !first ? 'left' : 'right'};
	@media (max-width: 700px) {
		width: 25px;
		min-width: 25px;
	}
`
const ManageMatch = styled.div`
	width: 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	z-index: 4;
	top: 0;
`;
const ButtonStyle = styled(Button)`
	background-color: ${({ playing }) => playing ? "white" : ""};
	border-radius: ${({ playing }) => playing ? "50px" : ""};
`
const HandleConfirm = ({ hideModal, action, selectedTeam, match }) => {
	const structure = useSelector(state => state.rounds.structure)
	console.log(structure)
	console.log(match.teams[0].score, match.teams[1].score)
	const description = () => {
		if (action === "Start") {
			return "Start the game between " + match.teams[0].player.name.toUpperCase() + " and " + match.teams[1].player.name.toUpperCase() + " ?"
		}
		else if (action === "End") {
			if ((match.teams[0].score === match.teams[1].score) && structure !== "robin")
				return "Score is equal!"
			return "End the game between " + match.teams[0].player.name.toUpperCase() + " and " + match.teams[1].player.name.toUpperCase() + " ?"
		}
		else if (action === "Select") {
			return ("Select this Team ?")
		}
	}
	const title = (action === "Select") ? "Select player" : (action + " The game")
	const buttonText = (action === "Select") ? action : (action + " game")
	const { id } = useParams();
	return (
		<ModalContainer>
			<Header>
				<ModalIcon src={(action === "End") ? endGameIcon : ((action === "Select") ? selectedTeam.avatar : startGameIcon)} />
				<h4>{(action === "Select") ? selectedTeam.name : title}</h4>
			</Header>
			<Footer>
				<Description>{description()}</Description>
			</Footer>
			<Buttons>
				<Button size="small" onClick={hideModal}>Cancel</Button>
				{((match.teams[0].score === match.teams[1].score) && structure !== "robin" && action === "End") ? "" : <Button size="small" variant="primary"
					onClick={async () => {
						let winnerID = 0;
						let matchID = match.id;
						let scorePlayer1 = 0;
						let scorePlayer2 = 0;
						if (action === "Start") {
							match.playing = true;
							match.teams[0].score = 0;
							match.teams[1].score = 0;
							axios.post(process.env.REACT_APP_START_MATCH_ENDPOINT + matchID).then((x) => {
							})
							// match.date = new Date();
						} else if (action === "End") {
							if (match.teams[0].score > match.teams[1].score) {
								winnerID = match.teams[0].playerID
							}
							else if (match.teams[0].score < match.teams[1].score) {
								winnerID = match.teams[1].playerID
							}
							console.log("")
							scorePlayer1 = match.teams[0].score;
							scorePlayer2 = match.teams[1].score;
							if (isNaN(scorePlayer1)) scorePlayer1 = parseInt(0);
							if (isNaN(scorePlayer2)) scorePlayer2 = parseInt(0);
							try {
								await axios.post(process.env.REACT_APP_TOURNAMENT_SET_WINNER_ENDPOINT, { matchID, winnerID, tournmentID: id, scorePlayer1, scorePlayer2 }, { withCredentials: true });
								match.finished = true;
								match.playing = false;
							} catch (e) {
								console.log(e)
							}
							if (match.finished) match.playing = false;
						}
						hideModal();
					}}>
					{buttonText}
				</Button>}
			</Buttons>
		</ModalContainer>
	);
};
window.admin = false;

const Summary = () => {
	let admin = window.admin
	const rounds = useSelector(state => state.rounds.data)
	const structure = useSelector(state => state.rounds.structure)
	const [currentRounds, setCurrentRounds] = useState((rounds) ? { winners: rounds.winnerBracket, losers: rounds.LoserBracket } : null)
	const adminId = useSelector(state => state.rounds.adminId)
	const userId = useSelector(state => state.user.data._id)
	useEffect(() => {
		console.log(rounds)
		if (rounds) {
			if (structure === "d_elim")
				setCurrentRounds({ winners: rounds.winnerBracket, losers: rounds.LoserBracket })
			else
				setCurrentRounds(rounds)
		}
		window.admin = (userId === adminId)
	}, [rounds, adminId, admin, structure, userId])
	const [checkVal, setCheckVal] = useState();
	const [confirmModal, setConfirmModal] = useState(false);
	const [currMatch, setMatch] = useState([]);
	const hideModal = () => setConfirmModal(false);
	const [newScore, setNewScore] = useState();
	useEffect(() => {
		if (newScore?.team)
			newScore.team.score = newScore?.score
	}, [newScore])
	const checkRound = (seed) => {
		if (!seed || !Array.isArray(seed)) return 0;
		for (let i = 0; i < seed.length; i++) {
			if (seed[i]?.teams?.[0]?.player && seed[i]?.teams?.[1]?.player)
				return 1;
		}
		return 0;
	}
	return (
		<Container>
			{(structure === "d_elim") ? <Text>WINNERS TOURNAMENT</Text> : ""}
			{
				(currentRounds && structure === "d_elim" && currentRounds.winners && Array.isArray(currentRounds.winners)) ? currentRounds.winners.map((round, index) => {
					return <div style={{ marginBottom: "32px" }}>
						{checkRound(round.seeds) ? <RoundText>{"ROUND " + (index + 1)}</RoundText> : ""}
						{
							round.seeds.map((match, matchIndex) => {
								return (match.teams[0].player && match.teams[1].player) &&
									<Match playing={match.playing} odd={matchIndex % 2}>
										<Modal isOpen={confirmModal} onRequestClose={hideModal} hideModal={hideModal}>
											<HandleConfirm
												hideModal={hideModal}
												roundIndex={index}
												seedIndex={matchIndex}
												match={currMatch}
												action={checkVal}
											/>
										</Modal>
										<Team first>
											{/* <Text playing={match.playing}>{replaceAll(match.date?.toLocaleDateString('en-US'), "/", ".")}</Text> */}
											<Info lose={(match.finished && (match.teams[0].score < match.teams[1].score))} first>
												<Text playing={match.playing} >{match.teams[0].player.name}</Text>
												{match?.teams?.[0]?.player?.avatar ? <Flag first src={match.teams[0].player.avatar} /> : null}
												<ScoreStyle
													disabled={(match.finished || !admin || (!match.finished && !match.playing))}
													value={parseInt(match.teams[0].score) || parseInt(0)}
													type="number"
													onChange={(e) => {
														match.teams[0].score = parseInt(e.target.value);
														console.log(typeof (parseInt(e.target.value)))
														setNewScore({
															score: parseInt(e.target.value),
															team: match.teams[0],
														})
													}
													}
													playing={match.playing}
													first
												/>
											</Info>
										</Team>
										<Text playing={match.playing} middle>-</Text>
										<Team >
											<Info lose={(match.finished && (match.teams[0].score > match.teams[1].score))}>
												<ScoreStyle
													playing={match.playing}
													disabled={(match.finished || !admin || (!match.finished && !match.playing))}
													value={parseInt(match.teams[1].score) || parseInt(0)}
													type="number"
													onChange={(e) => {
														match.teams[1].score = parseInt(e.target.value);
														console.log(typeof (parseInt(e.target.value)))
														setNewScore({
															score: parseInt(e.target.value),
															team: match.teams[1],
														})
													}
													}
												/>
												{match?.teams?.[1]?.player?.avatar ? <Flag src={match.teams[1].player.avatar} /> : null}
												<Text playing={match.playing}>{match.teams[1].player.name}</Text>
											</Info>
										</Team>
										{window.admin && match.teams[0]?.player && match.teams[1]?.player ? (
											<ManageMatch>
												{!match.playing &&
													!match.finished ? (
													<ButtonStyle playing={match.playing} style={{ margin: "0 auto 4px" }} icon onClick={() => {
														setCheckVal("Start");
														setConfirmModal(true)
														setMatch(match)
													}}><StartGameIcon /></ButtonStyle>
												) : (
													""
												)}
												{match.playing &&
													!match.finished ? (
													<ButtonStyle playing={match.playing} style={{ margin: "0 auto 4px" }} icon onClick={() => {
														setMatch(match)
														setCheckVal("End");
														setConfirmModal(true)
													}}><EndGameIcon style={{ fill: "black" }} /></ButtonStyle>
												) : (
													""
												)}
											</ManageMatch>
										) : (
											""
										)}
									</Match>
							})
						}
					</div>
				}) : ""
			}
			{(structure === "d_elim") ? <Text>LOSERS TOURNAMENT</Text> : ""}
			{
				(currentRounds && structure === "d_elim" && currentRounds.losers && Array.isArray(currentRounds.losers)) ? currentRounds.losers.map((round, index) => {
					return <div style={{ marginBottom: "32px" }}>
						{checkRound(round.seeds) ? <RoundText>{"ROUND " + (index + 1)}</RoundText> : ""}
						{
							round.seeds.map((match, matchIndex) => {
								return (match.teams[0].player && match.teams[1].player) &&
									<Match playing={match.playing} odd={matchIndex % 2}>
										<Modal isOpen={confirmModal} onRequestClose={hideModal} hideModal={hideModal}>
											<HandleConfirm
												hideModal={hideModal}
												roundIndex={index}
												seedIndex={matchIndex}
												match={currMatch}
												action={checkVal}
											/>
										</Modal>
										<Team first>
											{/* <Text playing={match.playing}>{replaceAll(match.date?.toLocaleDateString('en-US'), "/", ".")}</Text> */}
											<Info lose={(match.finished && (match.teams[0].score < match.teams[1].score))} first>
												<Text playing={match.playing} >{match.teams[0].player.name}</Text>
												{match?.teams?.[0]?.player?.avatar ? <Flag first src={match.teams[0].player.avatar} /> : null}
												<ScoreStyle
													playing={match.playing}
													disabled={(match.finished || !admin || (!match.finished && !match.playing))}
													value={parseInt(match.teams[0].score) || parseInt(0)}
													type="number"
													onChange={(e) => {
														match.teams[0].score = parseInt(e.target.value);
														console.log(typeof (parseInt(e.target.value)))
														setNewScore({
															score: parseInt(e.target.value),
															team: match.teams[0],
														})
													}
													}
													first />
											</Info>
										</Team>
										<Text playing={match.playing} middle>-</Text>
										<Team >
											<Info lose={(match.finished && (match.teams[0].score > match.teams[1].score))}>
												<ScoreStyle
													playing={match.playing}
													disabled={(match.finished || !admin || (!match.finished && !match.playing))}
													value={parseInt(match.teams[1].score) || parseInt(0)}
													type="number"
													onChange={(e) => {
														match.teams[1].score = parseInt(e.target.value);
														console.log(typeof (parseInt(e.target.value)))
														setNewScore({
															score: parseInt(e.target.value),
															team: match.teams[1],
														})
													}
													}
												/>
												{match?.teams?.[1]?.player?.avatar ? <Flag src={match.teams[1].player.avatar} /> : null}
												<Text playing={match.playing}>{match.teams[1].player.name}</Text>
											</Info>
										</Team>
										{window.admin && match.teams[0]?.player && match.teams[1]?.player ? (
											<ManageMatch>
												{!match.playing &&
													!match.finished ? (
													<ButtonStyle playing={match.playing} style={{ margin: "0 auto 4px" }} icon onClick={() => {
														setCheckVal("Start");
														setConfirmModal(true)
														setMatch(match)
													}}><StartGameIcon /></ButtonStyle>
												) : (
													""
												)}
												{match.playing &&
													!match.finished ? (
													<ButtonStyle playing={match.playing} style={{ margin: "0 auto 4px" }} icon onClick={() => {
														setMatch(match)
														setCheckVal("End");
														setConfirmModal(true)
													}}><EndGameIcon style={{ fill: "black" }} /></ButtonStyle>
												) : (
													""
												)}
											</ManageMatch>
										) : (
											""
										)}
									</Match>
							})
						}
					</div>
				}) : ""
			}
			{
				(currentRounds && structure !== "d_elim" && rounds && Array.isArray(rounds)) ? rounds.map((round, index) => {
					return <div style={{ marginBottom: "32px" }}>
						{checkRound(round.seeds) ? <RoundText>{"ROUND " + (index + 1)}</RoundText> : ""}
						{
							round.seeds.map((match, matchIndex) => {
								return (match.teams[0].player && match.teams[1].player) &&
									<Match playing={match.playing} odd={matchIndex % 2}>
										<Modal isOpen={confirmModal} onRequestClose={hideModal} hideModal={hideModal}>
											<HandleConfirm
												hideModal={hideModal}
												roundIndex={index}
												seedIndex={matchIndex}
												match={currMatch}
												action={checkVal}
											/>
										</Modal>
										<Team first>
											{/* <Text playing={match.playing}>{replaceAll(match.date?.toLocaleDateString('en-US'), "/", ".")}</Text> */}
											<Info lose={(match.finished && (match.teams[0].score < match.teams[1].score))} first>
												<Text playing={match.playing} >{match.teams[0].player.name}</Text>
												{match?.teams?.[0]?.player?.avatar ? <Flag first src={match.teams[0].player.avatar} /> : null}
												<ScoreStyle
													playing={match.playing}
													disabled={(match.finished || !admin || (!match.finished && !match.playing))}
													value={parseInt(match.teams[0].score) || parseInt(0)}
													type="number"
													onChange={(e) => {
														match.teams[0].score = parseInt(e.target.value);
														console.log(typeof (parseInt(e.target.value)))
														setNewScore({
															score: parseInt(e.target.value),
															team: match.teams[0],
														})
													}
													}
													first />
											</Info>
										</Team>
										<Text playing={match.playing} middle>-</Text>
										<Team >
											<Info lose={(match.finished && (match.teams[0].score > match.teams[1].score))}>
												<ScoreStyle
													playing={match.playing}
													disabled={(match.finished || !admin || (!match.finished && !match.playing))}
													value={parseInt(match.teams[1].score) || parseInt(0)}
													type="number"
													onChange={(e) => {
														match.teams[1].score = parseInt(e.target.value);
														console.log(typeof (parseInt(e.target.value)))
														setNewScore({
															score: parseInt(e.target.value),
															team: match.teams[1],
														})
													}
													}
												/>
												{match?.teams?.[1]?.player?.avatar ? <Flag src={match.teams[1].player.avatar} /> : null}
												<Text playing={match.playing}>{match.teams[1].player.name}</Text>
											</Info>
										</Team>
										{window.admin && match.teams[0]?.player && match.teams[1]?.player ? (
											<ManageMatch>
												{!match.playing &&
													!match.finished ? (
													<ButtonStyle playing={match.playing} style={{ margin: "0 auto 4px" }} icon onClick={() => {
														setCheckVal("Start");
														setConfirmModal(true)
														setMatch(match)
													}}><StartGameIcon /></ButtonStyle>
												) : (
													""
												)}
												{match.playing &&
													!match.finished ? (
													<ButtonStyle playing={match.playing} style={{ margin: "0 auto 4px" }} icon onClick={() => {
														setMatch(match)
														setCheckVal("End");
														setConfirmModal(true)
													}}><EndGameIcon style={{ fill: "black" }} /></ButtonStyle>
												) : (
													""
												)}
											</ManageMatch>
										) : (
											""
										)}
									</Match>
							})
						}
					</div>
				}) : ""
			}

		</Container >

	)
}

export default Summary